import { PanelsTopLeft } from "lucide-react";
import { cn } from "@/lib/utils";

type SiteShellProps = {
  map: React.ReactNode;
  sidebar: React.ReactNode;
  lower?: React.ReactNode;
  layoutMode?: "full" | "column";
};

export function SiteShell({
  map,
  sidebar,
  lower,
  layoutMode = "full",
}: SiteShellProps) {
  return (
    <main
      className={cn(
        "min-h-screen pt-16",
        layoutMode === "full"
          ? "lg:h-dvh lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(360px,420px)] lg:grid-rows-[minmax(0,1fr)_auto] lg:overflow-hidden"
          : "mx-auto flex max-w-7xl flex-col",
      )}
    >
      <section
        className={cn(
          "relative min-h-[72vh] min-w-0 overflow-hidden",
          layoutMode === "full" ? "lg:h-full lg:min-h-0" : "px-3",
        )}
      >
        {map}
      </section>
      <aside
        className={cn(
          "relative z-40 min-w-0 border-white/10 bg-background/92 backdrop-blur",
          layoutMode === "full"
            ? "border-l p-4 lg:h-full lg:w-full lg:overflow-y-auto lg:overscroll-contain"
            : "px-3 pb-4",
        )}
      >
        <div className="mb-4 hidden items-center gap-2 text-sm text-muted-foreground lg:flex">
          <PanelsTopLeft className="h-4 w-4" aria-hidden />
          Desktop full-screen intelligence layout
        </div>
        {sidebar}
      </aside>
      {lower ? (
        <section className="border-t border-white/10 bg-background/95 p-4 lg:col-span-2">
          {lower}
        </section>
      ) : null}
    </main>
  );
}
